import ReactAppWrapper from './ReactAppWrapper'

export default ReactAppWrapper
